$.fn.customCalendarComments = function (minDate, maxDate) {
    if (typeof $.fn.datepicker !== 'undefined') {
        let $self = $(this);

        let $input = $self.closest('.js-filter-input-holder').find('.js-input-date');
        let $label = $self.closest('.js-filter-input-holder').find('.js-label-date');

        const getMonthForLabel = function (monthNubmer) {
            switch (monthNubmer) {
                case 1:
                    return 'янв';
                case 2:
                    return 'фев';
                case 3:
                    return 'мар';
                case 4:
                    return 'апр';
                case 5:
                    return 'мая';
                case 6:
                    return 'июн';
                case 7:
                    return 'июл';
                case 8:
                    return 'авг';
                case 9:
                    return 'сен';
                case 10:
                    return 'окт';
                case 11:
                    return 'ноя';
                case 12:
                    return 'дек';
            }
        };

        /**
         * Устанавливает выбранное значение дат
         * @param {date} date 
         */
        const setDateInputValue = function (date) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1);
            let day = date.getDate();

            let monthLeadingZero = month.toString().padStart(2, '0');
            let dayLeadingZero = day.toString().padStart(2, '0');

            let dateString = `${dayLeadingZero}.${monthLeadingZero}.${year}`;
            let dateLabel = `${day} ${getMonthForLabel(month)} ${year}`;

            $input.val(dateString);

            $label.text(dateLabel);
            $label.addClass('active');
        };

        /**
         * Инициализация плагина
         */
        const init = function () {
            // Если подключен select2 - добавляем выбор месяца/года
            if (typeof $.fn.select2 !== 'undefined') {
                addCalendarHtml();
            }

            // Инициализация датапикера
            $self.datepicker({
                inline: true,
                minDate: minDate,
                maxDate: maxDate, // нельзя читать из будущего - у одних ребят была куча проблем из-за этого в 1985 году
                startDate: maxDate,
                toggleSelected: false,
                selectOtherMonths: false,
                onRenderCell: function (date, cellType) { // форматирование ячеек календаря
                    let datesArray = $self.data('dates');

                    let year = date.getFullYear();
                    let month = (date.getMonth() + 1).toString().padStart(2, '0');
                    let day = date.getDate().toString().padStart(2, '0');

                    let dateString = `${day}.${month}.${year}`;

                    if (typeof datesArray !== 'undefined' && cellType === 'day') {
                        if (datesArray.indexOf(dateString) !== -1) {
                            return {
                                classes: '-has-event-'
                            };
                        } else {
                            return {
                                disabled: true
                            };
                        }
                    }
                },
                onSelect: function (formattedDate, date) { // обработка выбора конкретной даты в календаре
                    setDateInputValue(date);
                }
            });
        };

        const addCalendarHtml = function () {
            $self.prepend($('<div>', {
                class: 'calendar-filter js-calendar-filter',
                append: [
                    $('<select>', {
                        class: 'js-select2 calendar-filter-month',
                        attr: {
                            'data-select2-class': 'select2-filter-month'
                        },
                        append: function () {
                            let monthArray = [
                                'Январь',
                                'Февраль',
                                'Март',
                                'Апрель',
                                'Май',
                                'Июнь',
                                'Июль',
                                'Август',
                                'Сентябрь',
                                'Октябрь',
                                'Ноябрь',
                                'Декабрь'
                            ];

                            return monthArray.map(function (el, index) {
                                return $('<option>', {
                                    value: index,
                                    text: el,
                                    selected: (index === maxDate.getMonth())
                                });
                            });
                        }
                    }),
                    $('<select>', {
                        class: 'js-select2 calendar-filter-year',
                        attr: {
                            'data-select2-class': 'select2-filter-year'
                        },
                        append: function () {
                            let minYear = minDate.getFullYear();
                            let maxYear = maxDate.getFullYear();
                            let optionsArray = [];

                            for (let i = minYear; i <= maxYear; i++) {
                                optionsArray.push($('<option>', {
                                    value: i,
                                    text: i,
                                    selected: i === maxDate.getFullYear()
                                }));
                            }

                            return optionsArray;
                        }
                    }),
                    $('<button>', {
                        class: 'js-hide-calendar calendar-close-btn',
                        type: 'button'
                    })
                ]
            }));

            /**
             * Инициализация select2 для полей выбора года/месяца
             */
            $self.find('.js-calendar-filter .js-select2').each(function () {
                let $select = $(this);

                $select.select2({
                    width: 'style',
                    dropdownParent: $select.parent(),
                    containerCssClass: $select.data('select2-class')
                });

                $select.on('select2:select', function () {
                    let datepicker = $self.data('datepicker');
                    let selectedYear = parseInt($self.find('.js-select2.calendar-filter-year').val());
                    let selectedMonth = (parseInt($self.find('.js-select2.calendar-filter-month').val()) + 1).toString().padStart(2, '0');

                    if (typeof datepicker !== 'undefined') {
                        datepicker.date = new Date(`${selectedYear}-${selectedMonth}-01`);
                    }
                });

                // Если подключен PerfectScrollbar - подключаем кастомный скролл в выпадающих списках
                if (typeof PerfectScrollbar !== 'undefined') {
                    $select.on('select2:open', function (e) {
                        $('.select2-results__options').each(function (index, el) {
                            if (typeof $(el).data('ps') === 'undefined') {
                                $(el).data('ps', new PerfectScrollbar(el, {
                                    suppressScrollX: true
                                }));
                            }

                            setTimeout(function () {
                                $(el).data('ps').update();
                            }, 100);
                        });
                    });
                }
            });

            // Страница не должна скроллиться, пока скроллится список опций
            $(document).on('wheel', '.select2-results__options', function (e) {
                e.preventDefault();
            });
        };

        init();
    }
};
